module.exports = __webpack_public_path__ + "static/media/saturdayflyer.794405d0.jpg";